import React from 'react';
import { Panel, Disclaimer, Badge } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { TradingReports } from './TradingReports';

export default function AdminTrading() {
  const { data: config } = useFetch('/config');
  return (
    <div className="space-y-6" data-testid="admin-trading">
      <TradingReports />
      <Panel title="Trading Operations & Exchange Integration">
        <div className="flex items-center justify-between py-3 border-b border-border">
          <div><div className="text-sm">Live Exchange Execution</div><div className="text-xs text-vj-grey">Submit real orders to a connected exchange adapter</div></div>
          <Badge tone={config?.live_trading_enabled ? 'green' : 'gold'}>{config?.live_trading_enabled ? 'Enabled' : 'Development mode'}</Badge>
        </div>
        <div className="flex items-center justify-between py-3 border-b border-border">
          <div><div className="text-sm">On-chain Withdrawal Signing</div><div className="text-xs text-vj-grey">Automated treasury signing of withdrawals</div></div>
          <Badge tone={config?.withdrawal_signing_enabled ? 'green' : 'gold'}>{config?.withdrawal_signing_enabled ? 'Enabled' : 'Development mode'}</Badge>
        </div>
        <div className="flex items-center justify-between py-3">
          <div><div className="text-sm">On-chain Deposit Detection</div><div className="text-xs text-vj-grey">Direct BNB Smart Chain node scanning of USDT BEP20 transfers</div></div>
          <Badge tone="green">Connected</Badge>
        </div>
      </Panel>
      <Disclaimer>Live exchange trading and automated withdrawal signing remain disabled until a provider, credentials, permissions, and risk checks are configured and tested. Provide exchange API keys and a treasury signer to enable them.</Disclaimer>
    </div>
  );
}
